var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuestic-tree-category" }, [
    _c(
      "div",
      {
        staticClass: "vuestic-tree-category__header",
        on: {
          click: function ($event) {
            _vm.isOpenCached = !_vm.isOpenCached
          },
        },
      },
      [
        _c(
          "div",
          { staticClass: "vuestic-tree-category__header-checkbox" },
          [
            _c("square-with-icon", {
              attrs: { iconClass: _vm.checkboxIconClass },
            }),
          ],
          1
        ),
        _vm.$slots.icon
          ? _c(
              "div",
              { staticClass: "vuestic-tree-category__header-icon" },
              [_vm._t("icon")],
              2
            )
          : _vm._e(),
        _c("div", { staticClass: "vuestic-tree-category__header-label" }, [
          _vm._v("\n      " + _vm._s(_vm.label) + "\n    "),
        ]),
      ]
    ),
    _vm.isOpenCached
      ? _c("div", { staticClass: "vuestic-tree-category__list-container" }, [
          _c(
            "div",
            { staticClass: "vuestic-tree-category__list-internal-container" },
            [_vm._t("default")],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }